import React from "react";
import { formatNumber } from "@SeemplicityDev/shared";
import useAddRef, { UseAddRefOptions } from "../useAddRef";
import Avatar from "../../../Components/Avatar/Avatar";

interface TopAssigneesPageProps extends UseAddRefOptions {
  data?: {
    opened_tickets_count: number;
    opened_findings_count: number;
    closed_tickets_count: number;
    closed_findings_count: number;
    assignees: {
      name: string;
      tickets_count: number;
      avg_ticket_time: number;
    }[];
  };
  hasQueues?: boolean;
}

const TopAssigneesPage: React.FC<TopAssigneesPageProps> = ({
  data,
  addRef,
  hasQueues,
}) => {
  const ref = useAddRef({ addRef });
  const {
    opened_tickets_count,
    opened_findings_count,
    closed_tickets_count,
    closed_findings_count,
    assignees,
  } = data || {};
  return (
    <div
      className={`eoy-page top-assignees-page ${hasQueues ? "has-queues" : ""}`}
      ref={ref}
    >
      <h4>
        <span className="main">
          {" "}
          Closed {formatNumber(closed_tickets_count)} Tickets for{" "}
          {formatNumber(closed_findings_count)} Findings*:{" "}
        </span>
        <span className="sub">
          You opened {formatNumber(opened_tickets_count)} tickets for{" "}
          {formatNumber(opened_findings_count)} findings
        </span>
      </h4>
      <h5>Top 3 Assignees:</h5>
      <div className="assignees-container">
        {assignees?.map((assignee, index) => {
          return (
            <React.Fragment key={assignee.name}>
              <div className="name-container">
                <Avatar name={assignee.name} size="m" />
                <span className="assignee-item-name">{assignee.name}</span>
              </div>
              <div className="count">
                {formatNumber(assignee.tickets_count)} Tickets
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div className="disclaimer">*Some tickets were opened before 2025</div>
    </div>
  );
};

export default TopAssigneesPage;
